'use es6';
/* eslint-disable prefer-rest-params */

/**
 * Returns an object with the debounced function and properties/methods to manage the debounce.
 *
 * @params {Function} callback
 * @params {Number} delay
 * @return {Object}
 */

export function debounceManager(callback, delay) {
  let isDebouncing = false;
  let timeoutId = null;
  let result; // Callback wrapper

  function handler(args) {
    timeoutId = null;
    isDebouncing = false;
    result = callback(...args);
  } // Debounced function


  function debounced() {
    clearTimeout(timeoutId);
    isDebouncing = true;
    timeoutId = setTimeout(handler, delay, arguments);
    return result;
  }

  return {
    /** Debounced function */
    debounced,

    /** True if debouncing is happening, false otherwise */
    get isDebouncing() {
      return isDebouncing;
    }

  };
}
/**
 * Returns a new function where one or more guards are invoked before the callback.
 * If any of the guards returns true, the callback will not be executed.
 *
 * @param {(Function|Array.<Function>)} guardFn
 * @param {Function}                    callback
 * @param {Object}                      context Optional
 * @return {Function}
 */

export function guard(guardFn, callback, context = null) {
  const guards = Array.isArray(guardFn) ? guardFn : [guardFn];
  return function guarded(...args) {
    if (guards.some(fn => fn.apply(context, args))) {
      return;
    }

    callback.apply(context, args);
  };
}